import React from 'react';
import { DialogTitle, Dialog, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import { DialogContentText, Tooltip, Typography } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const NewPasswordModal = function ({ open, handleClose, details }) {
  return (
    <Dialog onClose={ handleClose } open={ open }>
      <DialogTitle style={ { textAlign: 'center' } }>Login Password for  Business</DialogTitle>
      <DialogContent style={ { paddingTop: 0, paddingBottom: 0 } }>
        <div style={ { display: 'flex', padding: '0 35px 0 35px' } }>
          <Typography variant='h6'>
            Email:
            {' '}
            {details?.email}
          </Typography>

          <Tooltip title='Copy email'>
            <IconButton
              aria-label='copy-email'
              onClick={ () => {
                navigator.clipboard.writeText(details?.email);
              } }
            >
              <FileCopyIcon />
            </IconButton>
          </Tooltip>
        </div>

        {
          details?.password && (
            <div style={ { display: 'flex', padding: '0 35px 0 35px' } }>
              <Typography variant='h6'>
                Password:
                {' '}
                {details?.password}
              </Typography>

              <Tooltip title='Copy password'>
                <IconButton
                  aria-label='copy-password'
                  onClick={ () => {
                    navigator.clipboard.writeText(details?.password);
                  } }
                >
                  <FileCopyIcon />
                </IconButton>
              </Tooltip>
            </div>
          )
        }

        {
          details?.password && (
            <DialogContentText>
              <span style={ { fontWeight: 'bold' } }>Important:</span>
              {' '}
              This password is only visible once and cannot be retrieved in the future.
              Please save it now, as it will be permanently inaccessible after you close this dialog.
            </DialogContentText>
          )
        }

      </DialogContent>
      <DialogActions>
        <Button onClick={ handleClose } color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewPasswordModal;

